import { useState } from "react";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import { useClientUserQuery, useUpdateProfileMutation } from "../../hooks";
import TextInput from "../../../common/components/inputs/TextInput";

const AccountUpdateEmailDrawer = () => {
  const { data: clientUser, isLoading, error } = useClientUserQuery();
  const { close } = useCurrentDrawer();
  const [emailAddress, setEmailAddress] = useState(clientUser?.primary_contact_email?.email || "");

  const {
    mutate: updateProfile,
    isLoading: isUpdating,
    error: updateError,
  } = useUpdateProfileMutation({ onSuccess: close });

  if (isLoading) {
    return <DrawerLayout.Loading />;
  }

  if (!clientUser || error) {
    return <DrawerLayout.FetchError error={error} entityName="account" />;
  }
  const title = "Update email";

  return (
    <DrawerLayout>
      <DrawerLayout.Header title={title} onClose={close} />
      <DrawerLayout.Form
        submitText="Update email"
        canSubmit={!isLoading && !isUpdating}
        onSubmit={() => updateProfile({ email: emailAddress })}
        error={updateError}
      >
        <DrawerLayout.Form.Group>
          <TextInput
            value={emailAddress || ""}
            label="Email Address"
            onChange={setEmailAddress}
            errors={updateError?.errors.email}
          />
        </DrawerLayout.Form.Group>
      </DrawerLayout.Form>
    </DrawerLayout>
  );
};

export default AccountUpdateEmailDrawer;
